import Variable from '@/models/list/document-constructor/variable/index';
import { EVENT_ATTRIBUTES_TYPES } from '@/modules/UIDesign/Events/components/EventRequirements/constants';

export const getEventVariables = (variables, attributes, event) => {
  const hasNominations = event.hasNominations && event.actualNominations.some((item) => !item.isBase);
  const hasGroups = event.actualNominations.some((nomination) => nomination.hasGroupsWithoutBase
    && nomination.actualGroups.some((group) => !group.isBase));
  const names = new Set(variables.map((item) => item.name));
  const ids = new Set(variables.map((item) => item.value));
  const result = [...variables];

  attributes.forEach((attribute) => {
    const title = attribute.title?.trim();
    const value = `event_attribute_${attribute.id}`;
    if (!title || attribute.optionAssign === 'fio'
      || Number(attribute.type) === EVENT_ATTRIBUTES_TYPES.agreement || ids.has(value)) return;
    const name = names.has(title) ? `${title} (заявление)` : title;
    result.push(new Variable({ value, name, group: 'event_attributes', attribute_id: attribute.id, is_system_allowed: false }));
    ids.add(value);
    names.add(name);
  });

  return result.filter((item) => (item.value !== 'nomination_name' || hasNominations)
    && (item.value !== 'group_name' || hasGroups));
};

export const hasEventDependentVariables = (content = [], variables = []) => content.some((element) => {
  if (element.type !== 'text' || !element.value) return false;
  const container = document.createElement('div');
  container.innerHTML = element.value;
  const mentions = [...container.querySelectorAll('[data-type="mention"], .mention')];
  if (mentions.some((mention) => {
    const id = mention.getAttribute('data-id') || '';
    const group = mention.getAttribute('data-variable-group');
    return ['event_attributes', 'subordination_organization'].includes(group)
      || /^(event_attribute_|initial_level_org_|previous_level_org_)/.test(id);
  })) return true;
  return variables.some((variable) => {
    const restricted = variable.is_system_allowed === false
      || ['event_attributes', 'subordination_organization'].includes(variable.group);
    return restricted && (mentions.some((mention) => [variable.value, variable.name].includes(mention.getAttribute('data-id')))
      || container.textContent.includes(`@${variable.name}`));
  });
});
